import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "social-login"
    }}>{`Social Login`}</h1>
    <p>{`You can use a social network like `}<inlineCode parentName="p">{`Google`}</inlineCode>{` or `}<inlineCode parentName="p">{`Facebook`}</inlineCode>{` as a login provider like email/username and password. To set up social login, follow the below procedure,`}</p>
    <h2 {...{
      "id": "google"
    }}>{`Google`}</h2>
    <p>{`For Google, follow this procedure,`}</p>
    <ol>
      <li parentName="ol">{`At first go to Google Console dashboard (`}<a parentName="li" {...{
          "href": "https://console.cloud.google.com/"
        }}>{`https://console.cloud.google.com/`}</a>{`)`}</li>
      <li parentName="ol">{`From the console, create a new project
`}<img alt="Create_project.png" src={require("./images/Create_project.png")} /></li>
      <li parentName="ol">{`After creating the project, go to `}<inlineCode parentName="li">{`APIs & Services
 -> OAuth consent screen.`}</inlineCode>
        <img alt="oAuthScreen.png" src={require("./images/oAuthScreen.png")} /></li>
      <li parentName="ol">{`Create an `}<inlineCode parentName="li">{`External OAuth Consent.`}</inlineCode>{` Add all the required fields.`}</li>
      <li parentName="ol">{`Then, go to the `}<inlineCode parentName="li">{`credentials`}</inlineCode>{` section and create  `}<inlineCode parentName="li">{`OAuth Client ID.`}</inlineCode>
        <img alt="GAuth.png" src={require("./images/GAuth.png")} />{`
Add an `}<inlineCode parentName="li">{`Authorized redirect URIs`}</inlineCode>{`. The format of the URIs should be:`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`http://yourdomain.com/api/auth/callback/google
`}</code></pre>
    <p><img alt="Authorized_url.png" src={require("./images/Authorized_url.png")} />{`
6. Then you'll get your credentials,
`}<img alt="GAuthCredentials.png" src={require("./images/GAuthCredentials.png")} /></p>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">
        <p parentName="li">{`Then open `}<inlineCode parentName="p">{`api/.env`}</inlineCode>{` and add API ID and credentials,
`}<img alt="GAPISetup.png" src={require("./images/GAPISetup.png")} /></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Then go to this `}<inlineCode parentName="p">{`https://generate-secret.now.sh/32`}</inlineCode>{` site and generate a secret key.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Then open `}<inlineCode parentName="p">{`shop/.env`}</inlineCode>{` and add credentials to `}<inlineCode parentName="p">{`GOOGLE_CLIENT_ID`}</inlineCode>{` and `}<inlineCode parentName="p">{`GOOGLE_CLIENT_SECRET`}</inlineCode>{` and `}<inlineCode parentName="p">{`NEXTAUTH_URL`}</inlineCode>{` also add a `}<inlineCode parentName="p">{`SECRET`}</inlineCode>{` code.`}</p>
      </li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`NEXTAUTH_URL=YOUR_SHOP_DOMAIN
GOOGLE_CLIENT_ID=
GOOGLE_CLIENT_SECRET=
SECRET=
`}</code></pre>
    {
      /* ![GoogleGenerate.png](./images/GoogleGenerate.png) */
    }
    <p>{`After configuration, make sure you rebuild your project using this command,`}</p>
    <p>{`For REST API`}</p>
    <pre><code parentName="pre" {...{}}>{`yarn build:shop-rest
yarn build:admin-rest
`}</code></pre>
    <h2 {...{
      "id": "facebook"
    }}>{`Facebook`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Go to Facebook developer dashboard (`}<a parentName="p" {...{
            "href": "https://developers.facebook.com/apps/"
          }}>{`https://developers.facebook.com/apps/`}</a>{`)`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Then create a new app for chawkbazar`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`After that, set up `}<inlineCode parentName="p">{`Facebook Login.`}</inlineCode>{`
`}<img alt="FacebookApp.png" src={require("./images/FacebookApp.png")} />{`
`}<img alt="FBForWeb.png" src={require("./images/FBForWeb.png")} /></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Then provide all the necessary information.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`After that, go to the settings page, and on that page, you'll get all the credentials.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Then open `}<inlineCode parentName="p">{`api/.env`}</inlineCode>{` and add API ID and credentials,
`}<img alt="FBClientSecret.png" src={require("./images/FBClientSecret.png")} />{`
`}<img alt="FBAPICredentials.png" src={require("./images/FBAPICredentials.png")} /></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Then go to this `}<inlineCode parentName="p">{`https://generate-secret.now.sh/32`}</inlineCode>{` site and generate a secret key.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Then open `}<inlineCode parentName="p">{`shop/.env`}</inlineCode>{` and add credentials to `}<inlineCode parentName="p">{`FACEBOOK_CLIENT_ID`}</inlineCode>{`, `}<inlineCode parentName="p">{`FACEBOOK_CLIENT_SECRET`}</inlineCode>{`, `}<inlineCode parentName="p">{`NEXTAUTH_URL`}</inlineCode>{` also add a `}<inlineCode parentName="p">{`SECRET`}</inlineCode>{` code.`}</p>
      </li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`NEXTAUTH_URL=YOUR_SHOP_DOMAIN
FACEBOOK_CLIENT_ID=
FACEBOOK_CLIENT_SECRET=
SECRET=
`}</code></pre>
    {
      /* ![FBFrontendCredentials.png](./images/FBFrontendCredentials.png) */
    }
    <blockquote>
      <p parentName="blockquote">{`For Facebook, make sure you apply verification for the APP. Otherwise, the Facebook login won't work. (`}<a parentName="p" {...{
          "href": "https://developers.facebook.com/docs/app-review/"
        }}>{`https://developers.facebook.com/docs/app-review/`}</a>{`)`}</p>
    </blockquote>
    <p>{`After configuration, make sure you rebuild your project using this command,`}</p>
    <p>{`For REST API`}</p>
    <pre><code parentName="pre" {...{}}>{`yarn build:shop-rest
yarn build:admin-rest
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      